import styled from 'styled-components';

export default styled.div`
  text-align: center;
  margin: 5rem 0;
  font-weight: bold;
`;
